/** Unique tabs using H2 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.mainTabSection .tabMainContent').find('h2').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h2 has text inside
    if ($(this).text() != '') {
          //hide h2
        $(this).hide();
          //combine content between H2 elements
          $(this).nextUntil('h2').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML          
          $('.mainTabSection .tabContent').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap">' + tabContent + '</div></div>');          
          $('.mainTabSection .tabHeadings').append('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4></a>');      
      } else {  
          //hide empty H2
          $(this).hide();
      }
  });
  $(".tabHeadings .product-single__accordion__title:last-child").addClass("js-active");
  $(".tabContent .product-single__accordion__item:first-child").addClass("js-active");
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass);
    } else {
      //open and activate this item
      $(".js-unique-trigger").removeClass(activeClass);
      $(".product-single__accordion__item").removeClass(activeClass);
      $(thisItem)
      .addClass(activeClass);
      $(this).addClass(activeClass);
    }
    return false;
  });
});